<div class="modal modal__opened" [class.modal_size_744]="!requestInProgress">
  <ng-container *ngIf="!nextStep else step2">
    <div class="modal__close icon icon-close" (click)="close()"></div>
    <div class="modal__container">
      <div class="modal__img">
        <div class="modal-img modal-img_name_gift modal-img_size_192"></div>
      </div>
      <div class="modal__title modal__title-mb12 h2" *ngIf="!promo && !privetPlus">{{ 'deactivate-subscription-modal.privet-subscription' | translate }}</div>
      <div class="modal__title modal__title-mb12 h2" *ngIf="promo && !privetPlus">{{ 'deactivate-subscription-modal.privet-subscription-gift' | translate }}</div>
      <div class="modal__title modal__title-mb12 h2" *ngIf="!promo && privetPlus">{{ 'deactivate-subscription-modal.privet-plus-subscription' | translate }}</div>
      <div class="modal__title modal__title-mb12 h2" *ngIf="promo && privetPlus">{{ 'deactivate-subscription-modal.privet-plus-subscription-gift' | translate }}</div>
      <div class="modal__text" *ngIf="!privetPlus">{{ 'deactivate-subscription-modal.text-privet-new' | translate }}</div>
      <div class="modal__text" *ngIf="privetPlus">{{ 'deactivate-subscription-modal.text-privet-plus-new'| translate }}</div>
    </div>
    <div class="modal__buttons-row modal__buttons-mt40">
      <div class="button button_type_light" [innerHtml]="'subscription-info-modal.disconnect' | translate" (click)="showNextStep()"></div>
    </div>
  </ng-container>
</div>

<ng-template #step2>
  <ng-container *ngIf="!requestInProgress else loader">
    <ng-container *ngIf="!unsubscriptionCompleted else unsubscriptionRequestSent">
      <div class="modal__close icon icon-close" (click)="close()"></div>
      <div class="modal__container">
        <div class="modal__img">
          <div class="modal-img modal-img_name_disconnect modal-img_size_192"></div>
        </div>
        <div class="modal__title modal__title-mb12 h2" *ngIf="!promo && !privetPlus">{{ 'deactivate-subscription-modal.title-privet' | translate }}</div>
        <div class="modal__title modal__title-mb12 h2" *ngIf="promo && !privetPlus">{{ 'deactivate-subscription-modal.title-privet-gift' | translate }}</div>
        <div class="modal__title modal__title-mb12 h2" *ngIf="!promo && privetPlus">{{ 'deactivate-subscription-modal.title-privet-plus' | translate }}</div>
        <div class="modal__title modal__title-mb12 h2" *ngIf="promo && privetPlus">{{ 'deactivate-subscription-modal.title-privet-plus-gift' | translate }}</div>
        <div class="modal__text">{{ 'deactivate-subscription-modal.text-privet' | translate }}</div>
      </div>
      <div class="modal__buttons-row modal__buttons-mt40">
        <div class="button" (click)="close()">{{ 'deactivate-subscription-modal.stay-subscribed' | translate }}</div>
        <div class="button button_type_light" (click)="unsubscribe()">{{ 'deactivate-subscription-modal.unsubscribe' | translate }}</div>
      </div>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #loader>
  <div class="modal__container">
    <div class="modal__loader with-icon"></div>
  </div>
</ng-template>

<ng-template #unsubscriptionRequestSent>
  <div class="modal__close icon icon-close" (click)="close()"></div>
  <div class="modal__container">
    <div class="modal__img">
      <div class="modal-img modal-img_name_confirmation modal-img_size_192"></div>
    </div>
    <div class="modal__title modal__title-mb12 h2">{{ 'deactivate-subscription-modal.disconnecting' | translate }}</div>
    <div class="modal__text">{{ 'deactivate-subscription-modal.disconnecting-text' | translate }}</div>
  </div>
  <div class="modal__buttons-row modal__buttons-mt40">
    <div class="button" (click)="close()">{{ 'deactivate-subscription-modal.ok-button' | translate }}</div>
  </div>
</ng-template>
